import { parseJson } from './helpers';

export const parseWaitlistAutomationData = waitlistUser => {
  const automationData = parseJson(waitlistUser.automationData) || {};
  const gpt = automationData?.gptResponse;
  const acceptConfidence = gpt?.acceptanceLikelihood ?? (gpt?.decision === true ? gpt?.successLikelihood : null);
  const rejectConfidence = gpt?.rejectionLikelihood ?? (gpt?.decision === false ? 100 - (gpt?.successLikelihood ?? 50) : null);
  return { automationData, gpt, acceptConfidence, rejectConfidence };
};

const getYoutubeUrl = (username, channelId) => {
  if (username) return `https://youtube.com/@${username}`;
  if (channelId) return `https://youtube.com/channel/${channelId}`;
  return null;
};

export const getWaitlistUserSocialLinks = waitlistUser => {
  const accountFor = type => waitlistUser.linkedSocialAccounts?.find(account => account.type === type);
  const instagramAccount = accountFor('instagram');
  const youtubeAccount = accountFor('youtube');
  const instagramUsername = waitlistUser.instagramHandle || instagramAccount?.instagramUsername;
  const youtubeUsername = waitlistUser.youtubeHandle || youtubeAccount?.youtubeUsername;

  return [
    { key: 'instagram', url: instagramUsername ? `https://instagram.com/${instagramUsername}` : null, authenticated: !!instagramAccount },
    { key: 'tiktok', url: waitlistUser.tiktokHandle ? `https://tiktok.com/@${waitlistUser.tiktokHandle}` : null, authenticated: !!accountFor('tiktok') },
    { key: 'youtube', url: getYoutubeUrl(youtubeUsername, youtubeAccount?.youtubeChannelId), authenticated: !!youtubeAccount },
    { key: 'pinterest', url: waitlistUser.pinterestHandle ? `https://pinterest.com/${waitlistUser.pinterestHandle}` : null, authenticated: false },
    { key: 'substack', url: waitlistUser.substackHandle ? `https://${waitlistUser.substackHandle}.substack.com` : null, authenticated: false },
    { key: 'website', url: waitlistUser.website ? `https://${waitlistUser.website}` : null, authenticated: false }
  ];
};

export const waitlistUserNeedsDecision = waitlistUser => {
  const isUndecided = !waitlistUser.isAccepted && !waitlistUser.isRejected;
  const hasFullAccount = waitlistUser.User_id && !waitlistUser.isShopper;
  return isUndecided && !hasFullAccount;
};
export const waitlistUserIsAccepted = waitlistUser => waitlistUser.isAccepted;
export const waitlistUserIsRejected = waitlistUser => waitlistUser.isRejected;
export const waitlistUserIsScammer = waitlistUser => !!waitlistUser.isScammer;

export const getWaitlistLegalNameIfDifferentFromName = waitlistUser => {
  const legalName = [waitlistUser.legalFirstName, waitlistUser.legalLastName].filter(Boolean).join(' ');
  return legalName && legalName.toLowerCase() !== (waitlistUser.name || '').trim().toLowerCase() ? legalName : null;
};

export const brandWaitlistNeedsDecision = brandWaitlistApplication => {
  const isUndecided = !brandWaitlistApplication.isAccepted && !brandWaitlistApplication.isRejected;
  const alreadyHasAccount = brandWaitlistApplication.Brand_id;
  return isUndecided && !alreadyHasAccount;
};
export const brandWaitlistIsAccepted = brandWaitlistApplication => Boolean(brandWaitlistApplication.isAccepted);
export const brandWaitlistIsRejected = brandWaitlistApplication => Boolean(brandWaitlistApplication.isRejected);
